/* eslint-disable no-plusplus */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import React, { useEffect, useState } from "react";
import { arrayOf, bool, string } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import isEmpty from "lodash/isEmpty";
import CustomText from "pages/_components/CustomText/CustomText";
import * as i18n from "util/i18n";
import { isIOS } from "react-device-detect";

const DepositRateList = ({ depositsRates, ...props }) => {
    const { isDesktop, currency } = props;

    const [formattedRatesHeader, setFormattedRatesHeader] = useState([]);
    const [formattedRatesHeaderSub, setFormattedRatesHeaderSub] = useState([]);
    const [formattedDepositsRates, setFormattedDepositsRates] = useState([]);

    const [formattedRatesHeaderMobile, setFormattedRatesHeaderMobile] = useState([]);
    // const [formattedRatesHeaderSubMobile, setFormattedRatesHeaderSubMobile] = useState([]);
    const [formattedDepositsRatesMobile, setFormattedDepositsRatesMobile] = useState([]);

    useEffect(() => {
        const formattedDepositsRatesFunc = () => {
            const dataHeader = [];
            dataHeader.push({ column: 1, value: i18n.get("deposits.rates.depositedAmount") });

            const dataHeaderSub = [];
            dataHeaderSub.push({ column: 1, value: i18n.get("deposits.rates.terms") });

            const dataBody = [];

            depositsRates.forEach((rate, index) => {
                const dataRow = [];

                const keys = Object.keys(rate);
                let indexKey = 1;

                if (index === 0) {
                    for (const key in keys) {
                        if (keys[key] !== "dias") {
                            indexKey++;
                            dataHeader.push({ column: indexKey, value: keys[key] });
                            dataHeaderSub.push({ column: indexKey, value: i18n.get("deposits.rates.tna") });
                        }
                    }

                    setFormattedRatesHeader(dataHeader);
                    setFormattedRatesHeaderSub(dataHeaderSub);
                }

                indexKey = 0;

                for (const key in keys) {
                    indexKey++;
                    dataRow.push({ column: indexKey, value: rate[keys[key]] });
                }

                dataBody.push(dataRow);
            });

            setFormattedDepositsRates(dataBody);
        };

        formattedDepositsRatesFunc();
    }, [depositsRates]);

    useEffect(() => {
        const formattedDepositsRatesFuncMobile = () => {
            const dataBody = {};

            depositsRates.forEach(({ dias, ...rates }) => {
                Object.keys(rates).forEach((rateMoney) => {
                    dataBody[rateMoney] = [...(dataBody[rateMoney] || []), { dias, tna: rates[rateMoney] }];
                });
            });

            setFormattedRatesHeaderMobile(Object.keys(dataBody));
            setFormattedDepositsRatesMobile(dataBody);
        };

        formattedDepositsRatesFuncMobile();
    }, [depositsRates]);

    return !isEmpty(depositsRates) && isDesktop ? (
        <>
            <GridTable className={`deposits-rate-table underlined ${currency} mb-8`}>
                <GridTable.Header className="strong">
                    <GridTable.Container key={1} className="amount-deposited">
                        <GridTable.Data alignX="flex-start" alignY="center">
                            <CustomText text={formattedRatesHeader[0]?.value} textType="TEXT" keepSpaceIfNoText />
                        </GridTable.Data>
                        {formattedRatesHeader.slice(1).map((rate) => {
                            const a = rate.value.split(" a ");
                            return (
                                <GridTable.Data
                                    alignX="flex-start"
                                    flexDirection="column"
                                    className="width-max-content margin-cero-auto">
                                    <CustomText text={a[0]} textType="TEXT" keepSpaceIfNoText />
                                    <CustomText text={`a ${a[1]}`} textType="TEXT" keepSpaceIfNoText />
                                </GridTable.Data>
                            );
                        })}
                    </GridTable.Container>
                </GridTable.Header>
                <GridTable.Header className="light">
                    <GridTable.Container key={2}>
                        <GridTable.Data alignX="flex-start">
                            <CustomText text={formattedRatesHeaderSub[0]?.value} textType="TEXT" keepSpaceIfNoText />
                        </GridTable.Data>
                        {formattedRatesHeaderSub.slice(1).map((rate) => (
                            <GridTable.Data alignX={isDesktop ? "center" : "flex-start"}>
                                <CustomText text={rate.value} textType="TEXT" keepSpaceIfNoText />
                            </GridTable.Data>
                        ))}
                    </GridTable.Container>
                </GridTable.Header>
                {formattedDepositsRates.map((rowItem) => (
                    <GridTable.Container>
                        <GridTable.Data alignX="flex-start">
                            <CustomText text={rowItem[0].value} textType="TEXT" keepSpaceIfNoText />
                        </GridTable.Data>

                        {rowItem.slice(1).map((column) => (
                            <GridTable.Data alignX={isDesktop ? "center" : "flex-start"}>
                                <CustomText text={column.value} textType="TEXT" keepSpaceIfNoText />
                            </GridTable.Data>
                        ))}
                    </GridTable.Container>
                ))}
            </GridTable>
        </>
    ) : (
        <>
            <GridTable className={`deposits-rate-table underlined ${currency} box box-shadow p-0 mb-6`}>
                {formattedRatesHeaderMobile.map((rateMoneyText) => (
                    <>
                        <GridTable.Header className={isIOS ? "w-full deposits-radius" : "deposits-radius"}>
                            <GridTable.Container key={1} columnsTemplate="fixed">
                                <GridTable.Data
                                    alignX={isDesktop ? "center" : "flex-start"}
                                    style={{ flexDirection: "column" }}>
                                    <CustomText text="deposits.rates.depositedAmount" textType="I18N" />
                                    <CustomText
                                        className="font-weight-700"
                                        text={rateMoneyText}
                                        textType="TEXT"
                                        keepSpaceIfNoText
                                    />
                                </GridTable.Data>
                            </GridTable.Container>
                        </GridTable.Header>
                        <GridTable.Body>
                            {formattedDepositsRatesMobile[rateMoneyText].map(({ dias, tna }) => (
                                <>
                                    <GridTable.Container columnsTemplate="fixed">
                                        <GridTable.Data alignX={isDesktop ? "center" : "flex-start"}>
                                            <div className="d-flex flex-column">
                                                <CustomText text="depositSimulation.termInDays.label" textType="I18N" />
                                                <CustomText className="font-weight-600" text={dias} textType="TEXT" />
                                            </div>
                                        </GridTable.Data>
                                        <GridTable.Data alignX={isDesktop ? "center" : "flex-start"}>
                                            <div className="d-flex flex-column">
                                                <CustomText text="deposits.rates.tna" textType="I18N" />
                                                <CustomText className="font-weight-600" text={tna} textType="TEXT" />
                                            </div>
                                        </GridTable.Data>
                                    </GridTable.Container>
                                    <hr className="line-separator" />
                                </>
                            ))}
                        </GridTable.Body>
                        <GridTable.Footer className="pt-5" />
                    </>
                ))}
            </GridTable>
        </>
    );
};

DepositRateList.propTypes = {
    depositsRates: arrayOf().isRequired,
    isLoading: bool,
    isDesktop: bool,
    currency: string.isRequired,
};

DepositRateList.defaultProps = {
    isLoading: false,
    isDesktop: true,
};

export default DepositRateList;
